import React from "react";
import { Box, Typography, Container, Link } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#002fa7",
        color: "#fff",
        py: 3,
        px: 2,
        mt: 5,
        borderTop: "1px solid #ddd",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          rowGap: 2,
        }}
      >
        <Box>
          <Typography variant="body1" mt={1}>
            संपर्क :  +91 9623002815
          </Typography>
          <Typography variant="body1">
            मेल : {" "}
            <Link href="mailto:wardenebchostelshahada@gmail.com" color="inherit" underline="hover">
            wardenebchostelshahada@gmail.com
            </Link>
          </Typography>
          <Typography variant="body1">
            पत्ता : मातोश्री शासकीय आर्थिकदृष्टया मागासवर्गीय मुलांचे वसतिगृह, <br />
            प्रभूदत्तनगर, उंटावद, ता. शहादा, जि. नंदुरबार
          </Typography>

        </Box>

        <Box textAlign={{ xs: "left", sm: "right" }}>
          <Typography variant="body1">
            <Link href="https://technoweit.com" color="inherit" underline="hover" target="_blank">
              Technoweit
            </Link> {" "}
            द्वारे डिझाइन आणि विकसित
          </Typography>
          <Typography variant="body1">
            © {new Date().getFullYear()} सर्व हक्क राखीव.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
